<template>
  <div class="warehouse-profile-page warehouse-profile-page--add">

    <div class="warehouse-page-heading">
      <div class="warehouse-page-heading__icon" aria-hidden="true"><i class="fas fa-plus"></i></div>
      <div><span>Manajemen inventori</span><h1>Tambah gudang</h1><p>Tambahkan lokasi gudang dan susunan rak penyimpanan.</p></div>
    </div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :card-class="'warehouse-profile-card'">
          <template v-slot:body>
            <Form
              :form="form"
              purpose="add"
              :route="'warehouses'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/warehouses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        address: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gudang", route: "/masters/warehouses/list" },
      { title: "Daftar Gudang", route: "/masters/warehouses/list" },
      { title: "Tambah" },
    ])
  },

}

</script>
<style lang="scss" src="@/assets/sass/pages/_warehouse-profile-pages.scss"></style>
